import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { API_PREFIX, resolveUrl } from 'src/core/constants/api.constants';
import { SkillUserAssignmentDto } from 'src/core/models/skill/skill-user-assignment.dto';

const SKILL = `${API_PREFIX}/skill`;

@Injectable({
  providedIn: 'root',
})
export class SkillService {
  private readonly http = inject(HttpClient);

  updateUserAssignments(
    userId: string,
    assignments: SkillUserAssignmentDto[],
  ): Observable<void> {
    return this.http.put<void>(resolveUrl(`${SKILL}/user-assignments`), { userId, assignments });
  }
}
